import { Component, computed, inject, signal } from '@angular/core';
import { Icon } from '../../shared/components/icon';
import { Store } from '@ngrx/store';
import { User } from '../../features/login/models/user';
import { selectUser } from '../../state/auth/auth.selectors';
import { Router } from '@angular/router';
import { Divider } from '../../shared/components/divider';
import { AuthActions } from '../../state/auth/auth.actions';

@Component({
    selector: 'app-profile-header',
    template: `
<div class="dropdown-center relative">
    <button class="flex justify-center items-center gap-2 cursor-pointer m-1" aria-label="Accedi all'area personale" (click)="!user() ? router.navigate(['/login']) : openMenu()">
        @if(user()) {
            <div class="avatar avatar-placeholder">
                <div class="bg-white w-6 rounded-full">
                    <span class="text-[10px] font-semi-bold text-primary-blue">{{userLogged().initial}}</span>
                </div>
            </div>
            <p class="font-semi-bold uppercase text-sm">{{userLogged().fullName}}</p>
            <app-icon iconName="chevronDownUp" fill="white" [class.rotate-180]="isMenuOpen()" class="self-center" />
        } @else {
            <p class="font-semi-bold uppercase text-sm">area personale</p>
            <app-icon iconName="lock" stroke="white" className="w-4 h-4" />
        }
    </button>
    @if(isMenuOpen()) {
        <div class="bg-white absolute top-full left-1/2 -translate-x-1/2 mt-2 shadow-lg z-50">
            <div class="px-8 py-6 flex items-center justify-center gap-x-3">
                <div class="avatar avatar-placeholder">
                    <div class="bg-primary-blue w-8 rounded-full">
                        <span class="text-lg font-semi-bold text-white">{{userLogged().initial}}</span>
                    </div>
                </div>
                <p class="font-semi-bold text-lg text-black whitespace-nowrap">{{userLogged().fullName}}</p>
            </div>
            <app-divider [isOrizontalDivider]="true" borderColor="border-black/20 w-full"/>
            <button (click)="logout()" class="font-regular text-sm text-black py-2 text-center w-full cursor-pointer">
                Esci
            </button>
        </div>
    }
</div>
  `,
    imports: [Icon, Divider]
})
export class ProfileHeader {
    isMenuOpen = signal<boolean>(false);
    private readonly store = inject(Store);
    router = inject(Router);
    user = this.store.selectSignal<User | null>(selectUser);

    logout() {
        this.isMenuOpen.set(false);
        this.store.dispatch(AuthActions.logout({ spid: true }));
    }

    userLogged = computed(() => {
        const initial = `${this.user()?.nome.charAt(0).toUpperCase()}${this.user()?.cognome.charAt(0).toUpperCase()}`;
        const fullName = `${this.user()?.nome} ${this.user()?.cognome}`;
        return {
            initial: initial,
            fullName: fullName,
        };
    })

    openMenu() {
        this.isMenuOpen.set(!this.isMenuOpen());
    }

}
